<script setup>
  import { useLayoutStore } from '@/stores/layout';

  defineProps({
    title: String,
  });

  const layout = useLayoutStore();
</script>

<template>
  <v-app-bar scroll-behavior="elevate collapse" app>
    <v-app-bar-nav-icon @click="layout.toggleNavDrawer" />
    <v-app-bar-title class="ml-2">{{ title }}</v-app-bar-title>
    <v-spacer />
    <AppBarAvatar />
  </v-app-bar>
</template>

<style>
  /*
  * Already overriden in `vuetify.scss` using `$toolbar-collapsed-max-width`
  .v-toolbar--collapse {
    max-width: 150px !important;
  }

  * Set `v-app-bar-title` content style, font-size can be overriden in `vuetify.scss`
  .v-toolbar-title__placeholder {
    font-size: 1.5rem; // default is  20px
  }
  */
</style>
